document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('NotifPrefsToggle');
  var panel = document.getElementById('NotifPrefsPanel');
  var saveBtn = document.getElementById('NotifPrefsSave');
  var statusEl = document.getElementById('NotifPrefsStatus');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', function () {
    panel.style.display = (panel.style.display === 'none' || !panel.style.display) ? 'block' : 'none';
  });

  // Precargar el estado guardado de las categorías (tags) cuando OneSignal esté listo
  window.OneSignalDeferred = window.OneSignalDeferred || [];
  OneSignalDeferred.push(function (OneSignal) {
    try {
      var tags = OneSignal.User.getTags() || {};
      if ('cat_ventas' in tags) document.getElementById('NotifCatVentas').checked = tags.cat_ventas === '1';
      if ('cat_live' in tags) document.getElementById('NotifCatLive').checked = tags.cat_live === '1';
      if ('cat_recuperacion' in tags) document.getElementById('NotifCatRecuperacion').checked = tags.cat_recuperacion === '1';
      if ('cat_lanzamientos' in tags) document.getElementById('NotifCatLanzamientos').checked = tags.cat_lanzamientos === '1';
    } catch (e) { /* noop */ }
  });

  saveBtn.addEventListener('click', function () {
    statusEl.textContent = 'Guardando...';
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    OneSignalDeferred.push(async function (OneSignal) {
      try {
        await OneSignal.Notifications.requestPermission();
        var sel = {
          cat_ventas: document.getElementById('NotifCatVentas').checked ? '1' : '0',
          cat_live: document.getElementById('NotifCatLive').checked ? '1' : '0',
          cat_recuperacion: document.getElementById('NotifCatRecuperacion').checked ? '1' : '0',
          cat_lanzamientos: document.getElementById('NotifCatLanzamientos').checked ? '1' : '0'
        };
        OneSignal.User.addTags(sel);
        statusEl.textContent = 'Preferencias guardadas ✔';
        setTimeout(function () { panel.style.display = 'none'; }, 1400);
      } catch (e) {
        statusEl.textContent = 'No se pudo activar. Revisa permisos del navegador.';
      }
    });
  });
});
